/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import PrimaryButton from '../../../components/buttons/PrimaryButton'
import CheckInformationWrapper from '../CheckInformationWrapper'
import DefaultPage from '../DefaultPage'
import Image2 from '../../../assets/images/Image (1).png'
import numeral from 'numeral'

import { conversionAPI } from '../../../redux/Actions/postMethods'
import { AppStyles } from '../../../assets/styles/AppStyles'
import { useTheme } from '../../../utils/ThemeColorContext'
import { useNavigate } from 'react-router-dom'
import { InfoIcon } from '../../../assets/AppIcons'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { getApplications, getProfile } from '../../../redux/Actions/getMethods'
import JourneyRoute from '../../../navigation/JourneyRoute'
import { ActionTypes } from '../../../redux/Constants/actionTypes'
import SpinnerLarge from '../../../components/SpinnerLarge'
import { getAnalytics, logEvent } from 'firebase/analytics'
import captureException from '../../../utils/SentryHelper'
import TagManager from 'react-gtm-module'

const LoanApprovedFee = () => {
  const { token } = useSelector((state) => state.authReducer)
  const dispatch = useDispatch()
  const { profile, getApplication, loadingWholeScreen, loadingJourneyRoute } = useSelector(
    (state) => state.dataReducer,
  )

  const { color, isSmallScreen } = useTheme()
  const navigate = useNavigate()
  const [hasSentEvents, setHasSentEvents] = useState(false)

  const analytics = getAnalytics()
  const sendEvents = async () => {
    setHasSentEvents(true)
    const eventReference = 'finish_'  // event ref replacement for 'approved_loan_application_'
    const eventName = 'Finish' // event name replacement for 'Approved Loan Application'
    if (window.fbq) {
      window.fbq('trackCustom', eventName, 
        {
          /* applicationId: getApplication[0]?.id,
          loan_amount: getApplication[0]?.max_amount,
          loan_fee_percent: getApplication[0]?.fee_percentage, */
        },
      {eventID: `${eventReference}${getApplication[0]?.id}`}
      )
      const eventReference2 = 'finish2_'
      const eventName2 = 'Finish2'
      window.fbq('trackCustom', eventName2,
        {},
        {eventID: `${eventReference2}${getApplication[0]?.id}`}
      )
      //window.fbq('track', 'Purchase', {}, {eventID: `purchase_${getApplication[0]?.id}`})
    } else {
      captureException(new Error('Facebook pixel not found at loan approval stage'))
    }
    dispatch(
      conversionAPI({
        eventName: eventName,
        eventSourceUrl: `${process.env.REACT_APP_FRONTEND_URL}loanapprovedfee`,
        phoneNumber: token?.phone_number,
        email: token?.email,
        fName: token?.given_name,
        lName: token?.family_name,
        cognitoUserId: token?.sub,
        customData: {
          /* applicationId: getApplication[0]?.id,
          loan_amount: getApplication[0]?.max_amount,
          loan_fee_percent: getApplication[0]?.fee_percentage, */
        },
        dateOfBirth: token?.birthdate,
        userAgent: navigator.userAgent,
        eventId: `${eventReference}${getApplication[0]?.id}`,
        eventReference: eventReference,
      }),
    )
    if(window.ttq) {
      const ttEventReference = 'approved_loan_application_'
      const ttEventName = 'InitiateCheckout'
      window.ttq.track(ttEventName, {
        "contents": [
          {
            "content_id": getApplication[0]?.id,
            "price": getApplication[0]?.fee_percentage,
          }
        ],
        "value": getApplication[0]?.max_amount,
        "currency": "GBP"
      }, {
        "event_id": `${ttEventReference}${getApplication[0]?.id}`
      })
    }
    if (window.snaptr) {
      window.snaptr('track', 'PURCHASE', {
        price: getApplication[0]?.fee_percentage,
        currency: 'GBP',
        transaction_id: getApplication[0]?.id,
        user_email: token?.email,
        user_phone_number: token?.phone_number,
      })
    }
    if (window.gtag) {
      let user_data = {}
      if (
        profile?.first_name &&
        profile?.family_name &&
        profile?.address?.postcode
      ) {
        let address = { country: 'UK' }
        address.first_name = profile?.first_name
        address.last_name = profile?.family_name
        address.postal_code = profile?.address.postcode
        if (profile?.address?.line_1)
          address.street = profile?.address?.line_1
        if (profile?.address?.town) address.city = profile?.address.town
        if (
          profile?.address?.postal_county ||
          profile?.address?.traditional_county
        )
          address.region =
            profile?.address?.postal_county ||
            profile?.address?.traditional_county
        user_data = {
          email: token?.email,
          phone_number: token?.phone_number,
          address: address,
        }
      } else {
        user_data = {
          email: token?.email,
          phone_number: token?.phone_number,
        }
      }
      window.gtag('event', 'conversion', {
        send_to: process.env.REACT_APP_LOAN_APPROVED_GTAG_CONVERSION,
        loan_amount: getApplication[0]?.max_amount,
        user_data: user_data,
        value: getApplication[0]?.max_amount,
        currency: 'GBP',
        transaction_id: getApplication[0]?.id,
      })
      const tagManagerArgs = {
        dataLayer: {
          event: 'loan_approved',
          user_id: token?.sub,
          loan_amount: getApplication[0]?.max_amount,
          loan_fee_percentage: getApplication[0]?.fee_percentage,
          reason: getApplication[0]?.reason,
          status: getApplication[0]?.status,
          application: getApplication[0],
        }
      }
      TagManager.dataLayer(tagManagerArgs)
    }
    logEvent(analytics, 'approved_loan_application_client_side', {
      loan_amount: getApplication[0]?.max_amount,
      platform: 'web',
    })
    localStorage.setItem(`approvedEventSent_${getApplication[0]?.id}`, 'true')
  }

  useEffect(() => {
    if (!loadingWholeScreen && !hasSentEvents && profile?.id && getApplication[0]?.id && getApplication[0]?.status === 'APPROVED' && localStorage.getItem(`approvedEventSent_${getApplication[0]?.id}`) !== 'true') {
      setTimeout(() => {
        sendEvents()
      }, 3000)
    }
  }, [loadingWholeScreen, profile?.id, getApplication[0]?.id])

  useEffect(() => {
    if (JSON.parse(localStorage.getItem(`added_account`)) === true) {
      navigate('/direct-debit')
    }
  }, [])
  // ==================== Checking user status  =======================//
  useEffect(() => {
    let fetches = []
    const fetchData = async () => {
      if (!getApplication[0]?.id) {  
        dispatch({ type: ActionTypes.LOADING_SUCCESS_WHOLE_SCREEN })
        fetches.push(getApplications())
      }
      if (!profile?.id) {
        dispatch({ type: ActionTypes.LOADING_SUCCESS_WHOLE_SCREEN })
        fetches.push(dispatch(getProfile()))
      }
      if (fetches.length > 0) {
        await Promise.all(fetches)
        dispatch({ type: ActionTypes.LOADING_FAIL_WHOLE_SCREEN })
      }
      const application = getApplication[0]
      if (JSON.parse(localStorage.getItem(`added_account`))) {
        // dispatch({ type: ActionTypes.LOADING_FAIL_WHOLE_SCREEN })
        navigate('/direct-debit')
      } else if (
        application?.status === 'APPROVED' &&
        application?.offer_type !== 'UPDRAFT_CREDIT_INTEREST_ONLY'
      ) {
        //navigate('/loanapprovedfee')
        // do nothing
      } else {
        navigate('/address-detail')
      }
    }
    fetchData()
  }, [])

  const toLoanAmount = async () => {
    if (!hasSentEvents && profile?.id && getApplication[0]?.id && getApplication[0]?.status === 'APPROVED' && localStorage.getItem(`approvedEventSent_${getApplication[0]?.id}`) !== 'true') {
      await sendEvents()
    }
    if (getApplication[0]?.max_amount === getApplication[0]?.min_amount && getApplication[0]?.max_duration === getApplication[0]?.min_duration) {
      navigate('/customise-loan')
    } else {
      navigate('/loan-amount')
    }
  }

  return (
    <DefaultPage>
      {/* <RefferedRoute /> */}
      { (!loadingWholeScreen && (getApplication[0]?.status !== 'APPROVED' || getApplication[0]?.offer_type !== 'UPDRAFT_CREDIT_INTEREST_AND_FEE')) && <JourneyRoute />}
      {(loadingWholeScreen || loadingJourneyRoute) ? (
        <SpinnerLarge />
      ) : (
        <>
          <div className="md:flex md:w-[792px] m-[auto] pt-8 md:pt-0">
            <CheckInformationWrapper img={Image2}>
              <div className="w-full  space-y-8 md:space-y-10 ">
                <div className=" space-y-4 md:space-y-6 ">
                  <h1
                    style={
                      isSmallScreen
                        ? {
                            ...AppStyles.Title1,
                            color: color.Plum,
                          }
                        : {
                            ...AppStyles.LargeTitle2,
                            color: color.Plum,
                          }
                    }
                    className="text-center"
                  >
                    You’re&nbsp;
                    <span
                      style={
                        isSmallScreen
                          ? { ...AppStyles.Title1, color: color.Teal }
                          : { ...AppStyles.LargeTitle2, color: color.Teal }
                      }
                    >
                      Approved
                    </span>{' '}
                    for <br /> an Updraft loan
                  </h1>

                  <div
                    style={{ backgroundColor: color.LightGrey }}
                    className="w-full rounded-2xl "
                  >
                    <div
                      style={{ borderColor: color.MidGrey }}
                      className="cardBody  border-b h-[56px]"
                    >
                      <p
                        style={{
                          ...AppStyles.BodyBold,
                          color: color.Plum,
                          lineHeight: '24px',
                        }}
                      >
                        Your Offer
                      </p>
                      <p
                        style={{
                          ...AppStyles.BodyBold,
                          color: color.BlurpleTeal,
                        }}
                      >
                        {getApplication[0]?.max_amount !== getApplication[0]?.min_amount ? 'Up to ' : ''}£
                        {getApplication[0]?.max_amount
                          ? numeral(getApplication[0]?.max_amount).format('0,0')
                          : 0}{' '}
                      </p>
                    </div>
                    <div
                      style={{ borderColor: color.MidGrey }}
                      className="cardBody border-b  h-[56px]"
                    >
                      <p
                        style={{
                          ...AppStyles.BodyBold,
                          color: color.Plum,
                          lineHeight: '24px',
                        }}
                      >
                        Annual Interest Rate
                      </p>
                      <p
                        style={{
                          ...AppStyles.BodyBold,
                          color: color.BlurpleTeal,
                        }}
                      >
                        {!getApplication[0]?.interestRate
                          ? 0
                          : (getApplication[0]?.interestRate * 100).toFixed(2)}
                        %
                      </p>
                    </div>
                    <div className="cardBody ">
                      <div>
                        <p
                          style={{
                            ...AppStyles.BodyBold,
                            color: color.Plum,
                            lineHeight: '24px',
                          }}
                        >
                          Loan Fee
                        </p>
                        <p
                          style={{
                            ...AppStyles.Caption1,
                            color: color.Grey,
                            lineHeight: '24px',
                          }}
                        >
                          Split over the term of your loan
                        </p>
                      </div>

                      <p
                        style={{
                          ...AppStyles.BodyBold,
                          color: color.BlurpleTeal,
                        }}
                      >
                        {getApplication[0]?.max_amount !== getApplication[0]?.min_amount ? 'From ' : ''}£
                        {!getApplication[0]?.fee_percentage
                          ? '0'
                          : Math.ceil(getApplication[0]?.fee_percentage *
                            getApplication[0]?.min_amount)}
                      </p>
                    </div>
                  </div>
                  <div
                    style={{
                      marginTop: '24px',
                      backgroundColor: color.White,
                      borderColor: color.MidGrey,
                      minHeight: isSmallScreen && '74px',
                      alignItems: !isSmallScreen && 'flex-start',
                      // justifyContent: 'center',
                    }}
                    className="p-4 border rounded-2xl flex space-x-4"
                  >
                    <div>
                      <InfoIcon fill={color.BlurpleTeal} />
                    </div>
                    <p style={{ ...AppStyles.Body12Demi, color: color.Grey }}>
                      Your loan fee is {getApplication[0]?.fee_percentage * 100}% of
                      the amount you borrow. It is included in your monthly repayments
                      and it is spread evenly over the term of your loan.
                    </p>
                  </div>
                  {getApplication[0]?.requested_amount > getApplication[0]?.max_amount && (
                    <div
                      style={{
                        backgroundColor: color.White,
                        borderColor: color.MidGrey,
                        minHeight: isSmallScreen && '74px',
                        alignItems: !isSmallScreen && 'flex-start',
                      }}
                      className="p-4 border rounded-2xl flex space-x-4"
                    >
                      <div>
                        <InfoIcon fill={color.BlurpleTeal} />
                      </div>
                      <p style={{ ...AppStyles.Body12Demi, color: color.Grey }}>
                        It's a little lower than what you applied for, but it's important your monthly payments are affordable.
                      </p>
                    </div>
                  )}
                  {isSmallScreen && (
                    <div style={{ marginTop: '32px' }}>
                      <PrimaryButton
                        id={'customise-loan'}
                        text={(getApplication[0]?.max_amount === getApplication[0]?.min_amount && getApplication[0]?.max_duration === getApplication[0]?.min_duration) ? 'Continue' : 'Customise My Loan'}
                        onClick={toLoanAmount}
                      />
                    </div>
                  )}
                </div>
                {!isSmallScreen && (
                  <PrimaryButton
                    id={'customise-loan'}
                    text={(getApplication[0]?.max_amount === getApplication[0]?.min_amount && getApplication[0]?.max_duration === getApplication[0]?.min_duration) ? 'Continue' : 'Customise My Loan'}
                    onClick={toLoanAmount}
                  />
                )}
              </div>
            </CheckInformationWrapper>
          </div>
        </>
      )}
    </DefaultPage>
  )
}

export default LoanApprovedFee
